import { createQueryStore, createSessionPersistedStore, createPersistedStore, createMutationStore } from '@ferreri/minato-react-utils';
import * as React from 'react';
import { useMemo, useCallback, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { jsx, Fragment } from 'react/jsx-runtime';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/**
 * @deprecated this cookie will be removed
 */
var SESSION_COOKIE_KEY = 'session_token';

var apiClient$2 = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});
// TODO: remove after the app supports direct iam-svc access
apiClient$2.interceptors.request.use(function (config) {
  config.headers.set('X-Session-Token', Cookies.get(SESSION_COOKIE_KEY));
  return config;
});
apiClient$2.interceptors.response.use(null, function (error) {
  var _error$response;
  var currentError = error == null || (_error$response = error.response) == null || (_error$response = _error$response.data) == null ? void 0 : _error$response.error;
  var unique_identifier = (Math.random() + 1).toString(36).substring(4);
  if ((currentError == null ? void 0 : currentError.id) === 'session_inactive') {
    error.response.data.error = _extends({}, currentError, {
      code: 'SessionInvalidError',
      unique_identifier: unique_identifier,
      status_code: currentError == null ? void 0 : currentError.code
    });
  }
  if ((currentError == null ? void 0 : currentError.status) === 'Unauthorized') {
    error.response.data.error = _extends({}, currentError, {
      code: 'SessionInvalidError',
      unique_identifier: unique_identifier,
      status_code: currentError == null ? void 0 : currentError.code
    });
  }
  return Promise.reject(error);
});

var getSocialLoginLogout = function getSocialLoginLogout(params) {
  try {
    return Promise.resolve(apiClient$2.get(SOCIAL_LOGIN_LOGOUT, {
      params: {
        return_to: params.return_to
      }
    })).then(function (response) {
      return response.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var SOCIAL_LOGIN_LOGOUT = '/iam-svc/public/self-service/logout/browser';

var useSocialLoginLogout = function useSocialLoginLogout(return_to) {
  return createQueryStore({
    queryKey: ['logout', {
      return_to: return_to
    }],
    queryFn: function queryFn() {
      return getSocialLoginLogout({
        return_to: return_to
      });
    },
    refetchOnWindowFocus: false
  });
};

var SESSION_PERSISTED_KEY = 'Angeplus@session-persisted-store';
var SESSION_KEY = 'Angeplus@session';
var usePersistedSession = function usePersistedSession() {
  return createSessionPersistedStore(SESSION_KEY);
};
var useSavedSessionId = function useSavedSessionId() {
  return createPersistedStore('auth_session');
};
var useSavedAccountId = function useSavedAccountId() {
  return createPersistedStore('account_id');
};
var useSessionPersistedStoreData = function useSessionPersistedStoreData() {
  var _createPersistedStore = createPersistedStore(SESSION_PERSISTED_KEY, {
      identity: null,
      data: {}
    }),
    value = _createPersistedStore[0],
    setValue = _createPersistedStore[1],
    destroy = _createPersistedStore[2];
  return {
    value: value,
    setValue: setValue,
    destroy: destroy
  };
};
var useSessionPersistedStore = function useSessionPersistedStore(_ref) {
  var identityId = _ref.identityId,
    key = _ref.key,
    isLoading = _ref.isLoading;
  var _useSessionPersistedS = useSessionPersistedStoreData(),
    globalValue = _useSessionPersistedS.value,
    setGlobalValue = _useSessionPersistedS.setValue,
    destroyStore = _useSessionPersistedS.destroy;
  var _usePersistedSession = usePersistedSession(),
    destroySession = _usePersistedSession[2];
  var value = useMemo(function () {
    var _globalValue$data;
    if (isLoading) {
      return null;
    }
    if (Boolean(globalValue == null ? void 0 : globalValue.identity) && (globalValue == null ? void 0 : globalValue.identity) !== identityId) {
      destroyStore();
      return null;
    }
    return globalValue == null || (_globalValue$data = globalValue.data) == null ? void 0 : _globalValue$data[key];
  }, [key, globalValue, isLoading, identityId]);
  var setValue = useCallback(function (value) {
    var _extends2;
    if (!identityId && isLoading) {
      return;
    }
    setGlobalValue({
      identity: identityId,
      data: _extends({}, globalValue == null ? void 0 : globalValue.data, (_extends2 = {}, _extends2[key] = value, _extends2))
    });
  }, [globalValue, key, identityId, isLoading]);
  var destroy = useCallback(function () {
    var _extends3;
    setGlobalValue({
      identity: identityId,
      data: _extends({}, globalValue == null ? void 0 : globalValue.data, (_extends3 = {}, _extends3[key] = undefined, _extends3))
    });
  }, [key, globalValue, identityId]);
  var destroyAll = useCallback(function () {
    destroySession();
    destroyStore();
  }, [destroySession, destroySession]);
  return {
    isLoading: isLoading,
    value: value,
    setValue: setValue,
    destroy: destroy,
    destroyAll: destroyAll
  };
};

var LOGOUT_API = '/iam-svc/public/self-service/logout/api';
var WHOAMI = "/iam-svc/public/sessions/whoami";
var deleteLogoutApi = function deleteLogoutApi(session_token) {
  try {
    return Promise.resolve(apiClient$2["delete"](LOGOUT_API, {
      data: {
        session_token: session_token
      }
    })).then(function () {});
  } catch (e) {
    return Promise.reject(e);
  }
};
var getSession = function getSession() {
  try {
    return Promise.resolve(apiClient$2.get(WHOAMI)).then(function (response) {
      return response.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _excluded$3 = ["destroyAll"];
var useLogoutApi = function useLogoutApi() {
  return createMutationStore({
    mutationFn: deleteLogoutApi
  });
};
var useValidateSession = function useValidateSession() {
  var _useCurrentSession = useCurrentSession(),
    session = _useCurrentSession.data,
    isLoading = _useCurrentSession.isLoading;
  if (!session) {
    return {
      isValidSession: false,
      isLoading: isLoading
    };
  }
  return {
    isValidSession: true,
    isLoading: isLoading
  };
};
var useSession = function useSession(config) {
  if (config === void 0) {
    config = null;
  }
  return createQueryStore(_extends({
    queryKey: ['current_session'],
    queryFn: getSession,
    refetchOnWindowFocus: false,
    retry: false
  }, config));
};
var useCachedSession = function useCachedSession(config) {
  var _queryCurrentSession$;
  if (config === void 0) {
    config = null;
  }
  var _usePersistedSession = usePersistedSession(),
    sessionPersisted = _usePersistedSession[0],
    setSessionPersisted = _usePersistedSession[1],
    destroy = _usePersistedSession[2];
  var queryCurrentSession = useSession(config);
  var hasSessionPersisted = Boolean(sessionPersisted);
  var data = (_queryCurrentSession$ = queryCurrentSession.data) != null ? _queryCurrentSession$ : sessionPersisted;
  var isLoading = hasSessionPersisted ? false : queryCurrentSession.isLoading;
  var isFetching = hasSessionPersisted ? false : queryCurrentSession.isFetching;
  var _useSavedSessionId = useSavedSessionId(),
    saveSessionId = _useSavedSessionId[1];
  useEffect(function () {
    if (queryCurrentSession.isSuccess && Boolean(queryCurrentSession.data)) {
      setSessionPersisted(queryCurrentSession.data);
      saveSessionId(queryCurrentSession.data.id);
    }
  }, [queryCurrentSession.isSuccess, queryCurrentSession.data]);
  return _extends({}, queryCurrentSession, {
    data: data,
    isLoading: isLoading,
    isFetching: isFetching,
    destroy: destroy
  });
};
var useCurrentSession = function useCurrentSession(key) {
  var _queryCachedSession$d;
  var _useSavedSessionId2 = useSavedSessionId(),
    removeSession = _useSavedSessionId2[2];
  var _useSavedAccountId = useSavedAccountId(),
    removeAccountId = _useSavedAccountId[2];
  var queryCachedSession = useCachedSession();
  var identityId = (_queryCachedSession$d = queryCachedSession.data) == null || (_queryCachedSession$d = _queryCachedSession$d.identity) == null ? void 0 : _queryCachedSession$d.id;
  var _useSessionPersistedS = useSessionPersistedStore({
      key: key,
      identityId: identityId,
      isLoading: queryCachedSession.isLoading
    }),
    destroySessionPersistedStore = _useSessionPersistedS.destroyAll,
    storeInstance = _objectWithoutPropertiesLoose(_useSessionPersistedS, _excluded$3);
  var destroyAll = function destroyAll() {
    destroySessionPersistedStore();
    removeSession();
    removeAccountId();
  };
  return _extends({}, queryCachedSession, {
    storeInstance: storeInstance,
    destroyAll: destroyAll
  });
};

var useValidateSessionAccount = function useValidateSessionAccount() {
  var _useCurrentSession = useCurrentSession(),
    session = _useCurrentSession.data,
    isLoadingSession = _useCurrentSession.isLoading;
  var _useCurrentAccount = useCurrentAccount(),
    account = _useCurrentAccount.data,
    isLoadingAccount = _useCurrentAccount.isLoading;
  var isValidSessionAccount = Boolean(account == null ? void 0 : account.id);
  if (!session) {
    return {
      isValidSession: false,
      isValidSessionAccount: false,
      isLoading: isLoadingSession
    };
  }
  if (!isValidSessionAccount) {
    return {
      isValidSession: true,
      isValidSessionAccount: false,
      isLoading: isLoadingAccount
    };
  }
  return {
    isValidSession: true,
    isValidSessionAccount: true,
    isLoading: isLoadingAccount
  };
};

var useEnforceValidAccount = function useEnforceValidAccount() {
  var _useValidateSessionAc = useValidateSessionAccount(),
    isValidSessionAccount = _useValidateSessionAc.isValidSessionAccount,
    isValidSession = _useValidateSessionAc.isValidSession,
    isLoading = _useValidateSessionAc.isLoading;
  useEffect(function () {
    if (!isValidSessionAccount && !isLoading && isValidSession) {
      var linkUrl = new URL(window.location.origin + "/link/links/new/account");
      linkUrl.searchParams.append('redirect_to', window.location.href);
      window.location.replace(linkUrl);
    } else if (!isValidSession && !isLoading) {
      var identificationUrl = new URL(window.location.origin + "/auth/identification");
      identificationUrl.searchParams.append('redirect_to', window.location.href);
      window.location.replace(identificationUrl);
    }
  }, [isValidSessionAccount, isValidSession, isLoading]);
  return {
    isValidSessionAccount: isValidSessionAccount,
    isLoading: isLoading
  };
};

var useEnforceValidSession = function useEnforceValidSession() {
  var _useValidateSession = useValidateSession(),
    isValidSession = _useValidateSession.isValidSession,
    isLoading = _useValidateSession.isLoading;
  useEffect(function () {
    if (!isValidSession && !isLoading) {
      var identificationUrl = new URL(window.location.origin + "/auth/identification");
      identificationUrl.searchParams.append('redirect_to', window.location.href);
      window.location.replace(identificationUrl);
    }
  }, [isValidSession, isLoading]);
  return {
    isValidSession: isValidSession,
    isLoading: isLoading
  };
};

var _excluded$2 = ["data"];
var useIdentity = function useIdentity(key) {
  var _session$identity;
  var _useCurrentSession = useCurrentSession(key),
    session = _useCurrentSession.data,
    query = _objectWithoutPropertiesLoose(_useCurrentSession, _excluded$2);
  var impersonatedIdentity = session == null || (_session$identity = session.identity) == null || (_session$identity = _session$identity.metadata_public) == null ? void 0 : _session$identity.impersonated_identity;
  var loggedIdentity = session == null ? void 0 : session.identity;
  var isImpersonated = Boolean(impersonatedIdentity);
  var data = impersonatedIdentity || (session == null ? void 0 : session.identity);
  return _extends({}, query, {
    data: data,
    isImpersonated: isImpersonated,
    impersonatedIdentity: impersonatedIdentity,
    loggedIdentity: loggedIdentity
  });
};

var apiClient$1 = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

var _excluded$1 = ["account_id"],
  _excluded2 = ["account_id"];
var putAccountAsync = function putAccountAsync(_ref2) {
  var account_id = _ref2.account_id,
    data = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  try {
    return Promise.resolve(apiClient$1.put(ACCOUNT_ASYNC(account_id), data)).then(function (response) {
      return response.data.account;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var putAccount = function putAccount(_ref) {
  var account_id = _ref.account_id,
    data = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  try {
    return Promise.resolve(apiClient$1.put(ACCOUNT(account_id), data)).then(function (response) {
      return response.data.account;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var getAccountByIdentityId = function getAccountByIdentityId(identityId) {
  try {
    return Promise.resolve(apiClient$1.get(ACCOUNT_BY_IDENTITY(identityId))).then(function (response) {
      return response.data.account;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var getAccount = function getAccount(accountId) {
  try {
    return Promise.resolve(apiClient$1.get(ACCOUNT(accountId))).then(function (response) {
      return response.data.account;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var ACCOUNTS = '/account-svc/v1/accounts';
var ACCOUNT = function ACCOUNT(accountId) {
  return ACCOUNTS + "/" + accountId;
};
var ACCOUNT_BY_IDENTITY = function ACCOUNT_BY_IDENTITY(identityId) {
  return "/account-svc/v1/identities/" + identityId + "/account";
};
var ACCOUNT_ASYNC = function ACCOUNT_ASYNC(accountId) {
  return ACCOUNTS + "/" + accountId + "/update_async";
};

var _excluded = ["data", "storeInstance"];
var useAccount = function useAccount(accountId) {
  return createQueryStore({
    queryKey: ['account', accountId],
    queryFn: function queryFn() {
      return getAccount(accountId);
    },
    enabled: Boolean(accountId),
    refetchOnMount: true
  });
};
var useAccountByIdentity = function useAccountByIdentity(identityId) {
  return createQueryStore({
    queryKey: ['account_by_identity', identityId],
    queryFn: function queryFn() {
      return getAccountByIdentityId(identityId);
    },
    enabled: Boolean(identityId),
    refetchOnMount: true
  });
};
var useCurrentAccount = function useCurrentAccount() {
  var _useSavedAccountId = useSavedAccountId(),
    saveAccountId = _useSavedAccountId[1];
  var _useIdentity = useIdentity('account'),
    identity = _useIdentity.data,
    accountStoreInstance = _useIdentity.storeInstance,
    queryCurrentIdentity = _objectWithoutPropertiesLoose(_useIdentity, _excluded);
  var identityId = identity == null ? void 0 : identity.id;
  var queryAccount = useAccountByIdentity(identityId);
  var cachedAccount = accountStoreInstance.value;
  var hasCachedAccount = Boolean(cachedAccount);
  var data = hasCachedAccount ? cachedAccount : queryAccount.data;
  var isLoading = hasCachedAccount ? false : queryCurrentIdentity.isLoading || queryAccount.isLoading;
  var isFetching = hasCachedAccount ? false : queryCurrentIdentity.isFetching || queryAccount.isFetching;
  useEffect(function () {
    if (queryAccount.isSuccess && Boolean(queryAccount.data)) {
      accountStoreInstance.setValue(queryAccount.data);
      saveAccountId(queryAccount.data.id);
    }
  }, [queryAccount.isSuccess, queryAccount.data]);
  return _extends({}, queryAccount, {
    data: data,
    isLoading: isLoading,
    isFetching: isFetching,
    destroy: accountStoreInstance.destroy
  });
};
var useUpdateAccount = function useUpdateAccount() {
  var _useSessionPersistedS = useSessionPersistedStoreData(),
    value = _useSessionPersistedS.value,
    setValue = _useSessionPersistedS.setValue;
  return createMutationStore({
    mutationFn: putAccount,
    onSuccess: function onSuccess(data) {
      var _value$data;
      var userInfo = value == null ? void 0 : value.data;
      var accountData = (value == null || (_value$data = value.data) == null ? void 0 : _value$data.account) || {};
      setValue(_extends({}, value, {
        data: _extends({}, userInfo, {
          account: _extends({}, accountData, data)
        })
      }));
    }
  });
};
var useUpdateAccountAsync = function useUpdateAccountAsync() {
  var _useSessionPersistedS2 = useSessionPersistedStoreData(),
    value = _useSessionPersistedS2.value,
    setValue = _useSessionPersistedS2.setValue;
  return createMutationStore({
    mutationFn: putAccountAsync,
    onSuccess: function onSuccess(data) {
      var _value$data2;
      var userInfo = value == null ? void 0 : value.data;
      var accountData = (value == null || (_value$data2 = value.data) == null ? void 0 : _value$data2.account) || {};
      setValue(_extends({}, value, {
        data: _extends({}, userInfo, {
          account: _extends({}, accountData, data)
        })
      }));
    }
  });
};

var useAdminSession = function useAdminSession() {
  var _session$authenticati;
  var _useSession = useSession(),
    session = _useSession.data,
    isLoading = _useSession.isLoading;
  var isValidAdminSession = session == null || (_session$authenticati = session.authentication_methods) == null ? void 0 : _session$authenticati.some(function (authentication) {
    return authentication.method === 'oidc' && (authentication == null ? void 0 : authentication.provider) === 'grupoangelus';
  });
  return {
    isLoading: isLoading,
    isValidAdminSession: isValidAdminSession
  };
};

var ValidAdminSessionRoute = function ValidAdminSessionRoute(props) {
  var _useAdminSession = useAdminSession(),
    isLoading = _useAdminSession.isLoading,
    isValidAdminSession = _useAdminSession.isValidAdminSession;
  useEffect(function () {
    if (!isLoading && !isValidAdminSession) {
      var adminLoginUrl = new URL(window.location.origin + "/auth/admin/login");
      if (props.returnTo) {
        adminLoginUrl.searchParams.set('return_to', props.returnTo);
      }
      window.location.replace(adminLoginUrl);
    }
  }, [isLoading, isValidAdminSession, props.returnTo]);
  if (isValidAdminSession) {
    return /*#__PURE__*/jsx(Fragment, {
      children: props.children
    });
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: props.loadingComponent
  });
};

var apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

var getProfile = function getProfile(accountId) {
  try {
    return Promise.resolve(apiClient.get(ACCOUNTS_PROFILE(accountId))).then(function (response) {
      return response.data.profile;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var ACCOUNTS_PROFILE = function ACCOUNTS_PROFILE(accountId) {
  return "/profile-svc/v1/accounts/" + accountId + "/profile";
};

var useProfile = function useProfile(accountId) {
  return createQueryStore({
    queryKey: ['profile', accountId],
    queryFn: function queryFn() {
      return getProfile(accountId);
    },
    enabled: Boolean(accountId)
  });
};
var useCurrentProfile = function useCurrentProfile() {
  var _queryCurrentAccount$, _queryProfile$data;
  var queryCurrentSession = useCurrentSession('profile');
  var queryCurrentAccount = useCurrentAccount();
  var accountId = queryCurrentAccount == null || (_queryCurrentAccount$ = queryCurrentAccount.data) == null ? void 0 : _queryCurrentAccount$.id;
  var queryProfile = useProfile(accountId);
  var profileStoreInstance = queryCurrentSession.storeInstance;
  var cachedProfile = profileStoreInstance.value;
  var hasCachedProfile = Boolean(cachedProfile);
  var data = (_queryProfile$data = queryProfile.data) != null ? _queryProfile$data : cachedProfile;
  var isLoading = hasCachedProfile ? false : queryCurrentSession.isLoading || queryProfile.isLoading;
  var isFetching = hasCachedProfile ? false : queryCurrentSession.isFetching || queryProfile.isFetching;
  useEffect(function () {
    if (queryProfile.isSuccess && Boolean(queryProfile.data)) {
      profileStoreInstance.setValue(queryProfile.data);
    }
  }, [queryProfile.isSuccess, queryProfile.data]);
  return _extends({}, queryProfile, {
    data: data,
    isLoading: isLoading,
    isFetching: isFetching,
    destroy: profileStoreInstance.destroy
  });
};

var NoSessionRoute = function NoSessionRoute(props) {
  var _useCurrentSession = useCurrentSession(),
    destroyAll = _useCurrentSession.destroyAll;
  var _useSocialLoginLogout = useSocialLoginLogout(null),
    data = _useSocialLoginLogout.data,
    isLoadingBrowserLogout = _useSocialLoginLogout.isLoading;
  var _useLogoutApi = useLogoutApi(),
    mutate = _useLogoutApi.mutate,
    isLoadingApiLogout = _useLogoutApi.isLoading,
    isSuccessApiLogout = _useLogoutApi.isSuccess;
  React.useEffect(function () {
    var sessionToken = Cookies.get(SESSION_COOKIE_KEY);
    if (sessionToken) {
      mutate(sessionToken);
    }
  }, []);
  React.useEffect(function () {
    if (isSuccessApiLogout) {
      destroyAll();
    }
  }, [isSuccessApiLogout]);
  React.useEffect(function () {
    if (data != null && data.logout_url) {
      window.location.replace(data == null ? void 0 : data.logout_url);
      destroyAll();
    }
  }, [data == null ? void 0 : data.logout_url]);
  var isLoading = isLoadingBrowserLogout || isLoadingApiLogout;
  if (isLoading) return /*#__PURE__*/jsx(Fragment, {
    children: props.loadingComponent
  });
  return /*#__PURE__*/jsx(Fragment, {
    children: props.children
  });
};

var ValidAccountRoute = function ValidAccountRoute(props) {
  var _useEnforceValidAccou = useEnforceValidAccount(),
    isValidSessionAccount = _useEnforceValidAccou.isValidSessionAccount;
  if (isValidSessionAccount) {
    return /*#__PURE__*/jsx(Fragment, {
      children: props.children
    });
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: props.loadingComponent
  });
};

var ValidSessionRedirectRoute = function ValidSessionRedirectRoute(props) {
  var _useSession = useSession(),
    session = _useSession.data,
    isLoading = _useSession.isLoading;
  React.useEffect(function () {
    if (!isLoading && session) {
      document.location.assign(props.redirectUrl);
    }
  }, [props.redirectUrl, isLoading, session]);
  if (!isLoading && !session) return /*#__PURE__*/jsx(Fragment, {
    children: props.children
  });
  return /*#__PURE__*/jsx(Fragment, {
    children: props.loadingComponent
  });
};

var ValidSessionRoute = function ValidSessionRoute(props) {
  var _useEnforceValidSessi = useEnforceValidSession(),
    isValidSession = _useEnforceValidSessi.isValidSession;
  if (isValidSession) return /*#__PURE__*/jsx(Fragment, {
    children: props.children
  });
  return /*#__PURE__*/jsx(Fragment, {
    children: props.loadingComponent
  });
};

export { NoSessionRoute, ValidAccountRoute, ValidAdminSessionRoute, ValidSessionRedirectRoute, ValidSessionRoute, getSocialLoginLogout, useAccount, useAdminSession, useCachedSession, useCurrentAccount, useCurrentProfile, useCurrentSession, useEnforceValidAccount, useEnforceValidSession, useIdentity, useLogoutApi, usePersistedSession, useProfile, useSavedAccountId, useSavedSessionId, useSession, useSessionPersistedStore, useSessionPersistedStoreData, useSocialLoginLogout, useUpdateAccount, useUpdateAccountAsync, useValidateSession, useValidateSessionAccount };
//# sourceMappingURL=index.es.js.map
